import { createSlice } from '@reduxjs/toolkit';

// Set the initial state values of the state object that this slice will manage
const INITIAL_STATE = {
  isGetUsersTaxableLicensesInProgress: false,
  isGetUsersTaxableLicensesSuccess: false,
  usersTaxableLicenses: [],
  usersTaxableLicensesErrorMsg: '',
};

// Define the slice and generate actions, reducers with createSlice
export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: INITIAL_STATE,
  reducers: {
    usersTaxableLicensesStarted: (state) => {
      state.isGetUsersTaxableLicensesInProgress = true;
      state.isGetUsersTaxableLicensesSuccess = false;
      state.usersTaxableLicensesErrorMsg = '';
    },
    usersTaxableLicensesSucceeded: (state, action) => {
      state.isGetUsersTaxableLicensesInProgress = false;
      state.isGetUsersTaxableLicensesSuccess = true;
      state.usersTaxableLicenses = action.payload;
      state.usersTaxableLicensesErrorMsg = '';
    },
    usersTaxableLicensesFailure: (state, action) => {
      state.isGetUsersTaxableLicensesInProgress = false;
      state.isGetUsersTaxableLicensesSuccess = false;
      state.usersTaxableLicenses = [];
      state.usersTaxableLicensesErrorMsg = action.payload;
    },

    resetDashboardState: () => INITIAL_STATE,
  },
});

// Export actions that were generated by createSlice
export const {
  usersTaxableLicensesStarted,
  usersTaxableLicensesSucceeded,
  usersTaxableLicensesFailure,
  resetDashboardState,
} = dashboardSlice.actions;

// Export combined reducer that was generated by createSlice
// (this is a single reducer which is a combination of all reducers in the slice... it basically puts them in a switch statement)
export default dashboardSlice.reducer;
